"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorLayout = void 0;
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var withPolyfill_1 = __importDefault(require("react-resize-detector/build/withPolyfill"));
var react_transition_group_1 = require("react-transition-group");
var ROICalculatorWrapper_1 = require("./ROICalculatorWrapper");
var isNarrowVariant = function (contentWidth) {
    return (contentWidth !== null && contentWidth !== void 0 ? contentWidth : 0) < 750;
};
var ROICalculatorLayout = (function (_super) {
    __extends(ROICalculatorLayout, _super);
    function ROICalculatorLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalSidebarVisible = false;
        _this.handleToggleSidebarVisibility = function () {
            if (_this.props.onToggleSidebarVisible) {
                _this.props.onToggleSidebarVisible();
            }
            else {
                _this.internalSidebarVisible = !_this.sidebarVisible;
            }
        };
        return _this;
    }
    ROICalculatorLayout.prototype.render = function () {
        var _this = this;
        var _a = this.props, calculator = _a.calculator, result = _a.result, slider = _a.slider, backgroundImageUrl = _a.backgroundImageUrl, widgetId = _a.widgetId, wrapToggleSidebarButton = _a.wrapToggleSidebarButton;
        var buttonLabel = "".concat(this.sidebarVisible ? "Hide" : "Show", " calculator");
        var button = (react_1.default.createElement(kaleidoscope_1.Button, { onClick: this.handleToggleSidebarVisibility, type: kaleidoscope_1.ButtonType.Secondary, "aria-expanded": this.sidebarVisible, "aria-controls": "roi-calculator-panel-".concat(widgetId) }, buttonLabel));
        return (react_1.default.createElement(withPolyfill_1.default, null, function (_a) {
            var contentWidth = _a.width;
            return (react_1.default.createElement(mobx_react_1.Observer, null, function () {
                var _a;
                return (react_1.default.createElement(ROICalculatorWrapper_1.ROICalculatorWrapper, null,
                    react_1.default.createElement("div", { className: (0, classnames_1.default)("roi-calculator-layout", (_a = {},
                            _a["roi-calculator-layout--with-background-image"] = !!backgroundImageUrl,
                            _a["roi-calculator-layout--narrow"] = isNarrowVariant(contentWidth),
                            _a["roi-calculator-layout--extra-narrow"] = (contentWidth !== null && contentWidth !== void 0 ? contentWidth : 0) < 700,
                            _a)) },
                        react_1.default.createElement("div", { "data-qwilr-widgetid": widgetId, "data-qwilr-component": "show-hide-roi-calc-button", className: "roi-calculator-button qwilr-font" }, wrapToggleSidebarButton ? wrapToggleSidebarButton({ children: button }) : button),
                        react_1.default.createElement(react_transition_group_1.CSSTransition, { in: _this.sidebarVisible, timeout: kaleidoscope_2.AnimationDuration.Medium, mountOnEnter: true, unmountOnExit: true, onEnter: utils_1.forceReflow, classNames: "roi-calculator-panel-" },
                            react_1.default.createElement("div", { "data-qwilr-widgetid": widgetId, "data-qwilr-component": "roi-calculator-panel", className: "roi-calculator-panel" },
                                react_1.default.createElement("div", { className: "roi-calculator-panel__inner" },
                                    react_1.default.createElement(kaleidoscope_1.Layer, { offset: 2 }, function () { return calculator; })))),
                        react_1.default.createElement(withPolyfill_1.default, { handleWidth: true }, function (_a) {
                            var width = _a.width;
                            return (react_1.default.createElement(mobx_react_1.Observer, null, function () {
                                var _a;
                                return (react_1.default.createElement("div", { className: (0, classnames_1.default)("roi-main-panel", (_a = {},
                                        _a["roi-main-panel--with-sidebar"] = _this.sidebarVisible,
                                        _a["roi-main-panel--with-background-image"] = !!backgroundImageUrl,
                                        _a)) },
                                    react_1.default.createElement("div", { className: "roi-main-panel__background" }, _this.backgroundImage),
                                    react_1.default.createElement("div", { className: "roi-main-panel__contents" },
                                        react_1.default.createElement(kaleidoscope_1.Layer, { offset: 2 }, function () { return (react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement("div", { className: "roi-main-panel__item roi-main-panel__result" }, result({
                                                containerWidth: width,
                                                isNarrowVariant: isNarrowVariant(contentWidth),
                                            })),
                                            react_1.default.createElement("div", { className: "roi-main-panel__item qwilr-font" }, slider({ isNarrowVariant: isNarrowVariant(contentWidth) })))); }))));
                            }));
                        }))));
            }));
        }));
    };
    Object.defineProperty(ROICalculatorLayout.prototype, "backgroundImage", {
        get: function () {
            var _a = this.props, backgroundImageUrl = _a.backgroundImageUrl, backgroundImagePlaceholder = _a.backgroundImagePlaceholder;
            if (backgroundImageUrl) {
                return (react_1.default.createElement("div", { className: "roi-main-panel__background-image-container" },
                    react_1.default.createElement("div", { className: "roi-main-panel__background-image", style: { backgroundImage: "url(".concat(backgroundImageUrl, ")") } }),
                    react_1.default.createElement("div", { className: "roi-main-panel__background-tint-overlay" })));
            }
            if (backgroundImagePlaceholder) {
                return (react_1.default.createElement("div", { className: "roi-main-panel__background-image-container" },
                    react_1.default.createElement("div", { className: "roi-main-panel__background-image--with-placeholder" }, backgroundImagePlaceholder)));
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROICalculatorLayout.prototype, "sidebarVisible", {
        get: function () {
            if (this.props.onToggleSidebarVisible) {
                return this.props.sidebarVisible;
            }
            return this.internalSidebarVisible;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ROICalculatorLayout.prototype, "internalSidebarVisible", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorLayout.prototype, "handleToggleSidebarVisibility", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorLayout.prototype, "backgroundImage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorLayout.prototype, "sidebarVisible", null);
    ROICalculatorLayout = __decorate([
        mobx_react_1.observer
    ], ROICalculatorLayout);
    return ROICalculatorLayout;
}(react_1.default.Component));
exports.ROICalculatorLayout = ROICalculatorLayout;
